/*! towsons-help-search.js — find an answer by typing.
 *
 * The index is rendered into the page as JSON, so the search runs here: no
 * request per keystroke, and it works the same on every help page. Shopify's
 * own search does not index metaobjects, so this is not a shortcut around it
 * — it is the only way to search this content at all.
 *
 * Ranking is deliberately simple and explainable: a hit in the question beats
 * a hit in the summary, which beats one in the body, and a word that starts a
 * word beats one buried inside it. With a help centre of this size anything
 * cleverer would be harder to predict than it is to use.
 */
(function () {
  'use strict';

  function norm(s) { return String(s == null ? '' : s).toLowerCase(); }

  function score(item, terms) {
    var q = norm(item.q), s = norm(item.s), b = norm(item.b);
    var total = 0;
    for (var i = 0; i < terms.length; i++) {
      var t = terms[i];
      var inQ = q.indexOf(t), inS = s.indexOf(t), inB = b.indexOf(t);
      if (inQ < 0 && inS < 0 && inB < 0) return 0;          // every word must appear
      // A word that starts a word is what someone meant; one buried inside
      // another ("art" in "start") usually is not.
      var edge = new RegExp('(^|[^a-z0-9])' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (inQ >= 0) total += edge.test(q) ? 10 : 5;
      else if (inS >= 0) total += edge.test(s) ? 4 : 2;
      else total += edge.test(b) ? 2 : 1;
    }
    return total;
  }

  function highlight(text, terms) {
    var out = String(text == null ? '' : text);
    // Escaped first — the result goes in with innerHTML.
    out = out.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    terms.forEach(function (t) {
      if (!t) return;
      var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      out = out.replace(re, '<mark>$1</mark>');
    });
    return out;
  }

  function mount(root) {
    if (root.__towsonsHelpSearch) return;
    root.__towsonsHelpSearch = true;
    var input = root.querySelector('[data-help-search-input]');
    var out = root.querySelector('[data-help-search-out]');
    var holder = document.querySelector('[data-help-index]');
    if (!input || !out || !holder) return;

    var items = [];
    try { items = JSON.parse(holder.textContent) || []; } catch (e) { return; }
    if (!items.length) return;

    var active = -1;
    var shown = [];

    function close() { out.hidden = true; out.innerHTML = ''; active = -1; shown = []; }

    function run() {
      var terms = norm(input.value).split(/\s+/).filter(Boolean);
      if (!terms.length) { close(); return; }
      shown = items
        .map(function (it) { return { it: it, n: score(it, terms) }; })
        .filter(function (x) { return x.n > 0; })
        .sort(function (a, b) { return b.n - a.n; })
        .slice(0, 8)
        .map(function (x) { return x.it; });

      if (!shown.length) {
        out.innerHTML = '<p class="thcx__search-none">Nothing matched “' + highlight(input.value, []) + '”. Try fewer words.</p>';
        out.hidden = false;
        return;
      }
      out.innerHTML = shown.map(function (it, i) {
        return '<a class="thcx__search-hit" role="option" aria-selected="' + (i === 0 ? 'true' : 'false') + '" href="' + it.u + '">' +
          '<span class="thcx__search-q">' + highlight(it.q, terms) + '</span>' +
          (it.s ? '<span class="thcx__search-s">' + highlight(it.s, terms) + '</span>' : '') +
          '</a>';
      }).join('');
      out.hidden = false;
      active = 0;
      paint();
    }

    function paint() {
      var hits = out.querySelectorAll('.thcx__search-hit');
      for (var i = 0; i < hits.length; i++) {
        hits[i].classList.toggle('is-on', i === active);
        hits[i].setAttribute('aria-selected', i === active ? 'true' : 'false');
      }
    }

    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (input.value.trim()) run(); });
    input.addEventListener('keydown', function (e) {
      var hits = out.querySelectorAll('.thcx__search-hit');
      if (e.key === 'Escape') { input.value = ''; close(); input.blur(); return; }
      if (!hits.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = (active + 1) % hits.length; paint(); hits[active].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = (active - 1 + hits.length) % hits.length; paint(); hits[active].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'Enter') { if (active >= 0) { e.preventDefault(); window.location.href = hits[active].getAttribute('href'); } }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });

    // "/" jumps to the box, the way every documentation site does. Not while
    // somebody is typing somewhere else.
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      var tag = t && t.tagName ? t.tagName.toLowerCase() : '';
      if (tag === 'input' || tag === 'textarea' || (t && t.isContentEditable)) return;
      e.preventDefault();
      input.focus();
      input.select();
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-help-search]'), mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
